/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import AdoptionTypeIcon from 'icons/AdoptionTypeIcon';

const messages = defineMessages({
  title: {id: 'navigation.instructional-materials.adoption-types'},
});

const AdoptionTypesItem = () => (
  <RouteLinkItem
    iconBefore={AdoptionTypeIcon}
    route="midas/instructional-materials/adoption-types"
    title={messages.title}
  />
);

export default AdoptionTypesItem;
